const BENEFITS = [
  {
    icon: 'ri-time-line',
    title: 'Save Hours Every Week',
    body: 'Stop spending evenings writing product copy and resizing images for every platform. AdForge does it in minutes so you can focus on growing your store.',
    metric: '8+ hrs/week saved',
  },
  {
    icon: 'ri-shopping-bag-line',
    title: 'More Sales, Less Spend',
    body: 'AI-written copy is tested and optimized for conversions. Better ads mean more add-to-carts, more checkouts, and a lower cost per purchase.',
    metric: 'Avg. 3.1x more sales',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Higher ROAS on Every Campaign',
    body: 'AdForge uses proven ecommerce ad frameworks — scarcity, social proof, benefit-led headlines — so your ads convert browsers into buyers.',
    metric: '4.2x avg. ROAS',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Stop Wasting Ad Budget',
    body: 'Weak creative kills campaigns. AI-generated ads are built to perform from day one, so every dollar you spend on ecommerce advertising works harder.',
    metric: '58% lower cost per purchase',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'No Agency Fees',
    body: 'Ecommerce agencies charge $2,000–$8,000/month for what AdForge does in minutes. Keep that margin in your business.',
    metric: 'Save $24k+/year',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Unlimited Creative Variations',
    body: 'Test different hooks, headlines, and product images without starting over. Regenerate any element with one click and scale what works.',
    metric: 'Unlimited A/B testing',
  },
];

export default function EcommerceBenefits() {
  return (
    <section className="py-20 lg:py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-400 uppercase tracking-widest mb-3">
            Why Ecommerce Stores Choose AdForge
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
            Real Benefits for Real Store Owners
          </h2>
          <p className="text-base text-stone-400 max-w-xl mx-auto">
            AdForge isn&apos;t just another marketing tool. It&apos;s built specifically for{' '}
            <strong className="text-white">ecommerce brands</strong> that need results, not complexity.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b) => (
            <div
              key={b.title}
              className="bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4 hover:bg-white/8 transition-colors duration-200"
            >
              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-orange-500/20 text-orange-400 flex-shrink-0">
                  <i className={`${b.icon} text-xl`} />
                </div>
                <h3 className="text-base font-bold text-white leading-snug">{b.title}</h3>
              </div>
              <p className="text-sm text-stone-400 leading-relaxed">{b.body}</p>
              <div className="mt-auto pt-4 border-t border-white/10">
                <span className="text-sm font-black text-orange-400">{b.metric}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
